import React from 'react'
import { Field } from 'formik'
import MuiPhoneNumber from 'material-ui-phone-number'

const PhoneNumberInputWrapper = ({ field, name, ...overrides }) => {
  const phoneNumberInputConfig = {
    color: 'primary',
    defaultCountry: 'us',
    disableAreaCodes: true,
    fullWidth: true,
    name,
    size: 'medium',
    variant: 'standard',
    ...field,
    ...overrides,
  }

  return <Field component={MuiPhoneNumber} {...phoneNumberInputConfig} />
}

export default PhoneNumberInputWrapper
